import { combineReducers } from 'redux';

import query from './reducers/query';
import search from './reducers/search';
import session from './reducers/session';
import ui from './reducers/ui';

const nullReducer = state => ({ ...state });

export default combineReducers({
  availableDatabaseOptions: state => state || [],
  currentUser: nullReducer,
  query,
  defaultTaskAssignee: nullReducer,
  features: nullReducer,
  paths: nullReducer,
  search,
  session,
  ui
});
